import {
  FUNCTIONS_FETCH,
  FUNCTIONS_FETCH_SUCCESS,
  FUNCTIONS_FETCH_ERROR,
  FUNCTIONS_SELECT_FUNCTION,
  FUNCTION_DETAILS_FETCH,
  FUNCTION_DETAILS_FETCH_ERROR,
  FUNCTION_DETAILS_FETCH_SUCCESS,
  PROCEDURE_EDIT,
  PROCEDURE_ADD,
  PROCEDURE_SAVE_SUCCESS,
  FUNCTION_UPDATE_WORKFLOW_SUCCESS,
  PROCEDURE_ADD_TO_WORKFLOW_SUCCESS,
  PROJECT_FUNCTION_FETCH_DETAILS,
  FUNCTION_UPDATE_NOTIFICATIONS,
  FUNCTION_UPDATE_NOTIFICATIONS_SUCCESS,
  FUNCTION_UPDATE_NOTIFICATIONS_ERROR,
  FUNCTIONS_EDIT_MANAGER_OF_FUNCTIONS,
  FUNCTIONS_UPDATE_IWPP_APPROVERS,
  FUNCTIONS_UPDATE_IWPP_APPROVERS_SUCCESS,
  FUNCTIONS_UPDATE_IWPP_APPROVERS_ERROR,
  FUNCTIONS_FETCH_IWPP_APPROVERS,
  FUNCTIONS_FETCH_IWPP_APPROVERS_SUCCESS,
  FUNCTIONS_FETCH_IWPP_APPROVERS_ERROR,
  FUNCTIONS_DELETE_IWPP_APPROVERS,
  FUNCTIONS_DELETE_IWPP_APPROVERS_SUCCESS,
  FUNCTIONS_DELETE_IWPP_APPROVERS_ERROR,
  GBUS_FETCH,
  GBUS_FETCH_SUCCESS,
  GBUS_FETCH_ERROR,
  MY_RR_DOCS,
  MY_RR_DOCS_FETCH_SUCCESS
} from "../reduxActions/Types";

import _ from "lodash";

const BLANK_PROCEDURE = {
  name: "",
  id: "",
  sdn: "",
  rev: "",
  effectiveDate: null,
  submitByDate: null,
  url: "",
  iwpp: false,
};

const INITIAL_STATE = {
  fetchingFunctions: false,
  functions: null,
  functionsFetchError: false,
  fetchingFunctionDetails: false,
  functionDetailsFetchError: null,
  selectedFunction: null,
  selectedFunctionDetails: null,
  blankProcedure: { ...BLANK_PROCEDURE },
  procedureBeingEdited: null,
  fetchingFunctionNotifications: false,
  functionFetchNotificationsError: false,
  fetchingGbus: false,
  gbusFetchError: false,
  gbus: null,
  myRRDocs: null
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // case PROCEDURE_ADD_TO_WORKFLOW_SUCCESS :
    // case PROCEDURE_SAVE_SUCCESS : {

    //   if(action.payload.projectId)

    //   if(state.selectedFunction.id === action.payload.functionId)
    //   {
    //     let procedures = [...state.selectedFunctionDetails.procedures];

    //     const procedureIndex = procedures.findIndex(procedure => procedure.id === action.payload.id);

    //     if(procedureIndex === -1)
    //     {
    //       procedures.push(action.payload);

    //     } else {
    //       procedures[procedureIndex] = action.payload;
    //     }

    //     procedures = _.sortBy(procedures,['name']);

    //     const selectedFunctionDetails = {...state.selectedFunctionDetails,procedures}
    //     return {...state,selectedFunctionDetails};

    //   }else {
    //     return {...state};
    //   }

    // }
    // case PROCEDURE_ADD : {
    //   return {
    //     ...state,
    //     procedureBeingEdited: {...BLANK_PROCEDURE}
    //   };
    // }
    // case PROCEDURE_EDIT : {
    //   return {
    //     ...state,
    //     procedureBeingEdited: action.payload
    //   };
    // }
    case FUNCTIONS_FETCH:
      return {
        ...state,
        fetchingFunctions: true,
        functionsFetchError: false,
      };
    case FUNCTIONS_FETCH_SUCCESS:
      return {
        ...state,
        functions: action.payload,
        fetchingFunctions: false,
      };
    case FUNCTIONS_FETCH_ERROR:
      return {
        ...state,
        fetchingFunctions: false,
        functionsFetchError: true,
      };
    case FUNCTIONS_SELECT_FUNCTION:
      return {
        ...state,
        selectedFunction: action.payload,
        selectedFunctionDetails: null,
      };
    case FUNCTION_DETAILS_FETCH:
      return {
        ...state,
        fetchingFunctionDetails: true,
        functionDetailsFetchError: null,
      };
    case FUNCTION_DETAILS_FETCH_ERROR:
      return {
        ...state,
        fetchingFunctionDetails: false,
        functionDetailsFetchError: action.payload,
      };
    case FUNCTION_UPDATE_WORKFLOW_SUCCESS: {
      const selectedFunctionDetails = {
        ...state.selectedFunctionDetails,
        ...action.payload,
      };
      return {
        ...state,
        selectedFunctionDetails,
      };
    }
    case FUNCTION_DETAILS_FETCH_SUCCESS:
      let selectedFunctionDetails = action.payload;
      if (!selectedFunctionDetails.workflowSteps) {
        selectedFunctionDetails.workflowSteps = [];
      }
      return {
        ...state,
        fetchingFunctionDetails: false,
        selectedFunctionDetails: selectedFunctionDetails,
      };
    // case FUNCTION_FETCH_NOTIFICATIONS:
    //   return {
    //     ...state,
    //     fetchingFunctionNotifications: true,
    //     functionFetchNotificationsError: false
    //   };
    // case FUNCTION_FETCH_NOTIFICATIONS_SUCCESS:
    //     const {notifications} = action.payload
    //     return {
    //       ...state,
    //       notifications,
    //       fetchingFunctionNotifications:false
    //     };
    // case FUNCTION_FETCH_NOTIFICATIONS_ERROR:
    //     return {
    //       ...state,
    //       fetchingFunctionNotifications:false,
    //       functionFetchNotificationsError:true
    //   };
    case FUNCTION_UPDATE_NOTIFICATIONS_SUCCESS: {
      const selectedFunctionDetails = {
        ...state.selectedFunctionDetails,
        ...action.payload,
      };
      return {
        ...state,
        selectedFunctionDetails,
      };
    }
    case FUNCTIONS_EDIT_MANAGER_OF_FUNCTIONS: {
      const workflowSteps = [
        {
          stepLabel: "IWPP",
        },
      ];

      const selectedFunctionDetails = {
        id: 0,
        name: "Manager of Functions",
        workflowSteps,
      };
      return {
        ...state,
        selectedFunctionDetails,
      };
    }
    case FUNCTIONS_FETCH_IWPP_APPROVERS: {

      const selectedFunctionDetails = { ...state.selectedFunctionDetails, }
      selectedFunctionDetails.approversFormValues = [];
      return { ...state, selectedFunctionDetails };
    }
    case FUNCTIONS_DELETE_IWPP_APPROVERS_SUCCESS:
    case FUNCTIONS_UPDATE_IWPP_APPROVERS_SUCCESS:
    case FUNCTIONS_FETCH_IWPP_APPROVERS_SUCCESS: {
      const selectedFunctionDetails = { ...state.selectedFunctionDetails };
      selectedFunctionDetails.approversFormValues = action.payload.map(
        (approver) => ({
          ...approver,
          proxy: !approver.primary
            ? {
              bun: approver.userBun,
              displayName: approver.userDisplayName,
            }
            : null,
          primary: approver.primary
            ? {
              bun: approver.userBun,
              displayName: approver.userDisplayName,
            }
            : null,
        })
      );
      return { ...state, selectedFunctionDetails };
    }
    case GBUS_FETCH:
      return {
        ...state,
        fetchingGbus: true,
        gbusFetchError: false,
      };
    case GBUS_FETCH_SUCCESS:
      return {
        ...state,
        gbus: action.payload,
        fetchingGbus: false,
      };
    case GBUS_FETCH_ERROR:
      return {
        ...state,
        fetchingGbus: false,
        gbusFetchError: true,
      };
    case MY_RR_DOCS:
      return {
        ...state,
        myRRDocs: action.payload,
      };
    case MY_RR_DOCS_FETCH_SUCCESS:
      return {
        ...state,
        myRRDocs: action.payload,
      };

    case 'RESET_ALL_REDUX_STATE':
      return INITIAL_STATE;
    default:
      return state;
  }
};
